// Margaret & Birdie — quick add met kleur- en maatkeuze vanaf de productkaart.
// Vervangt de standaard "Choose"-modal, die niet werkt met de aangepaste productpagina.
import { CartLinesUpdateEvent } from '@shopify/events';

const STYLE = `
.mbqa{border:0;padding:0;margin:auto auto 0;width:100%;max-width:100%;max-height:88vh;border-radius:14px 14px 0 0;background:#fffaf5;color:#2f4034;box-shadow:0 -8px 40px rgb(0 0 0 / .18)}
@media (min-width:750px){.mbqa{margin:auto;max-width:720px;border-radius:12px}}
.mbqa::backdrop{background:rgb(20 25 21 / .45)}
.mbqa__inner{display:grid;grid-template-columns:120px 1fr;gap:16px;padding:20px 18px 18px;overflow-y:auto;max-height:88vh;box-sizing:border-box}
@media (min-width:750px){.mbqa__inner{grid-template-columns:260px 1fr;gap:24px;padding:28px}}
.mbqa__img{width:100%;aspect-ratio:3/4;object-fit:cover;border-radius:8px;background:#efe8dc}
.mbqa__info{display:flex;flex-direction:column;gap:12px;min-width:0}
.mbqa__title{font-size:1rem;line-height:1.35;margin:0;padding-right:28px}
.mbqa__title a{color:inherit;text-decoration:none}
.mbqa__price{display:flex;gap:8px;align-items:baseline;font-weight:600;color:#b85c38}
.mbqa__price s{color:#8b8178;font-weight:400;font-size:.9em}
.mbqa__opt{display:flex;flex-direction:column;gap:6px}
.mbqa__label{font-size:.8rem;letter-spacing:.04em;text-transform:uppercase;color:#5c6b5e}
.mbqa__label b{text-transform:none;letter-spacing:0;color:#2f4034;font-weight:600}
.mbqa__vals{display:flex;flex-wrap:wrap;gap:6px}
.mbqa__val{font:inherit;font-size:.85rem;padding:7px 12px;border:1px solid #e2dccf;border-radius:4px;background:#fff;color:#2f4034;cursor:pointer;line-height:1.1}
.mbqa__val[aria-pressed="true"]{background:#2f4034;border-color:#2f4034;color:#fff}
.mbqa__val:disabled{opacity:.4;text-decoration:line-through;cursor:not-allowed}
.mbqa__val:focus-visible,.mbqa__add:focus-visible,.mbqa__close:focus-visible{outline:2px solid #b85c38;outline-offset:2px}
.mbqa__add{grid-column:1/-1;font:inherit;font-weight:600;padding:14px;border:0;border-radius:4px;background:#2f4034;color:#fff;cursor:pointer;margin-top:4px}
.mbqa__add:disabled{opacity:.55;cursor:not-allowed}
.mbqa__link{grid-column:1/-1;text-align:center;font-size:.85rem;color:#5c6b5e}
.mbqa__close{position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:50%;border:1px solid #e2dccf;background:#fff;color:#2f4034;cursor:pointer;font-size:18px;line-height:1}
.mbqa__err{grid-column:1/-1;color:#a3341f;font-size:.85rem;margin:0}
`;

let dialog;
let state = null;

const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

function money(cents) {
  const currency = window.Shopify?.currency?.active || 'AUD';
  return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
  }).format(cents / 100);
}

function ensureDialog() {
  if (dialog) return dialog;
  const style = document.createElement('style');
  style.textContent = STYLE;
  document.head.appendChild(style);
  dialog = document.createElement('dialog');
  dialog.className = 'mbqa';
  dialog.setAttribute('aria-label', 'Quick add');
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close();
  });
  document.body.appendChild(dialog);
  return dialog;
}

function findVariant(selected) {
  return state.product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
}

function reachable(index, value) {
  return state.product.variants.some(
    (v) => v.available && v.options.every((o, i) => (i === index ? o === value : !state.selected[i] || o === state.selected[i]))
  );
}

function render() {
  const { product, selected, url } = state;
  const variant = findVariant(selected);
  const img =
    (variant && variant.featured_image && variant.featured_image.src) ||
    (product.featured_image ? (product.featured_image.startsWith('//') ? 'https:' + product.featured_image : product.featured_image) : '');
  const price = variant ? variant.price : product.price;
  const compare = variant ? variant.compare_at_price : product.compare_at_price;

  const optionsHtml = product.options
    .map((name, i) => {
      const values = [...new Set(product.variants.map((v) => v.options[i]))];
      const buttons = values
        .map((val) => {
          const pressed = selected[i] === val;
          const disabled = !reachable(i, val);
          return `<button type="button" class="mbqa__val" data-i="${i}" data-v="${encodeURIComponent(val)}" aria-pressed="${pressed}" ${disabled ? 'disabled' : ''}>${esc(val)}</button>`;
        })
        .join('');
      return `<div class="mbqa__opt"><span class="mbqa__label">${esc(typeof name === 'string' ? name : name.name)}: <b>${esc(selected[i] || '')}</b></span><div class="mbqa__vals">${buttons}</div></div>`;
    })
    .join('');

  const canAdd = variant && variant.available;
  dialog.innerHTML = `
    <div class="mbqa__inner">
      <button type="button" class="mbqa__close" aria-label="Close">×</button>
      <img class="mbqa__img" src="${img}${img.includes('?') ? '&' : '?'}width=520" alt="">
      <div class="mbqa__info">
        <h2 class="mbqa__title"><a href="${url}">${esc(product.title)}</a></h2>
        <div class="mbqa__price">${money(price)}${compare > price ? `<s>${money(compare)}</s>` : ''}</div>
        ${optionsHtml}
      </div>
      <button type="button" class="mbqa__add" ${canAdd ? '' : 'disabled'}>${canAdd ? 'Add to cart' : 'Select an available option'}</button>
      <p class="mbqa__err" hidden></p>
      <a class="mbqa__link" href="${url}${variant ? '?variant=' + variant.id : ''}">View full details</a>
    </div>`;

  dialog.querySelector('.mbqa__close').addEventListener('click', () => dialog.close());
  dialog.querySelectorAll('.mbqa__val').forEach((btn) =>
    btn.addEventListener('click', () => {
      const i = Number(btn.dataset.i);
      state.selected[i] = decodeURIComponent(btn.dataset.v);
      if (!findVariant(state.selected)?.available) {
        const fallback = state.product.variants.find((v) => v.available && v.options[i] === state.selected[i]);
        if (fallback) state.selected = [...fallback.options];
      }
      render();
    })
  );
  dialog.querySelector('.mbqa__add').addEventListener('click', addToCart);
}

async function addToCart() {
  const variant = findVariant(state.selected);
  if (!variant) return;
  const btn = dialog.querySelector('.mbqa__add');
  const err = dialog.querySelector('.mbqa__err');
  btn.disabled = true;
  btn.textContent = 'Adding…';

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  let deferred;
  try {
    deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variant.id), quantity: 1 }],
        promise: deferred.promise,
      })
    );
  } catch (e) {
    deferred = null;
  }

  try {
    const res = await fetch((window.Theme?.routes?.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');

    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (deferred) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'mb-quick-add',
          sourceId: 'mb-quick-add',
          itemCount: 1,
          productId: String(state.product.id),
          sections: data.sections,
          didError: false,
        },
      });
    }
    dialog.close();
    // Zorg dat de winkelwagen opent, ook als het thema dat niet automatisch doet.
    setTimeout(() => {
      const drawer = document.querySelector('#cart-drawer');
      if (drawer && typeof drawer.showDialog === 'function' && !drawer.querySelector('dialog[open]')) drawer.showDialog();
    }, 350);
  } catch (e) {
    if (deferred) deferred.reject(e);
    err.hidden = false;
    err.textContent = e.message;
    btn.disabled = false;
    btn.textContent = 'Add to cart';
  }
}

async function open(url) {
  ensureDialog();
  const clean = url.split('?')[0].split('#')[0];
  const product = await fetch(clean + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const first = product.variants.find((v) => v.available) || product.variants[0];
  state = { product, url: clean, selected: [...first.options] };
  render();
  dialog.showModal();
}

window.addEventListener(
  'click',
  (event) => {
    const own = event.target.closest?.('[data-mb-qa]');
    if (own && own.dataset.url) {
      event.preventDefault();
      event.stopImmediatePropagation();
      open(own.dataset.url).catch(() => {
        window.location.href = own.dataset.url;
      });
      return;
    }
    const btn = event.target.closest?.('.quick-add__button--choose');
    if (!btn) return;
    const card = btn.closest('product-card');
    const link = card?.querySelector('a.product-card__link');
    if (!link?.href) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(link.href).catch(() => {
      window.location.href = link.href;
    });
  },
  true
);
